module.exports = __webpack_public_path__ + "static/img/アセット 40@2x.b54f421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 40@2x.png
// module id = jfzQ
// module chunks = 1